<template>
  <v-card>
    <v-card-title class="headline">
      {{ $t('main.TUTORIAL_HEAD') }}
    </v-card-title>
    <v-card-text>
      <video ref="tutorialVideo" controls preload="auto" style="width: 100%; height: auto;"
        src="/static/tutorial.mp4" autoplay>
        <track kind="subtitles" src="ruta_al_archivo_subtitulos.vtt" srclang="es" default />
      </video>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="cerrarModal">{{ $t('questionnaire.itemHelpDialog.CLOSE_BUTTON') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'TutorialVideo',
  methods: {
    cerrarModal () {
      // Detener el video y resetearlo al inicio.
      if (this.$refs.tutorialVideo) {
        this.$refs.tutorialVideo.pause()
        this.$refs.tutorialVideo.currentTime = 0
      }
      this.$emit('close')
    },
    mounted () {
      // Intentar reproducir el video al montar el componente.
      // Si autoplay está habilitado y el video está silenciado, esto debería funcionar sin problemas.
      if (this.$refs.tutorialVideo) {
        this.$refs.tutorialVideo.play().catch(error => {
          console.warn('No se pudo reproducir el video automáticamente:', error)
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialVideo.vue